import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { LucideAngularModule, CheckCircle2, XCircle, X } from 'lucide-angular';
import { ToastService } from '../../../core/services/toast.service';

@Component({
  selector: 'app-toast-container',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [LucideAngularModule],
  template: `
    <div
      class="fixed left-1/2 top-4 z-[9999] flex w-96 max-w-[92vw] -translate-x-1/2 flex-col gap-2"
    >
      @for (toast of toastService.toasts(); track toast.id) {
        <div
          class="flex items-start gap-3 rounded-lg border px-4 py-3 shadow-lg bg-white"
          [class]="{
            'border-success-200': toast.type === 'success',
            'border-error-200': toast.type === 'error'
          }"
        >
          @if (toast.type === 'success') {
            <lucide-icon [img]="CheckCircle2" class="mt-0.5 h-5 w-5 shrink-0 text-success-600" [strokeWidth]="2" />
          } @else {
            <lucide-icon [img]="XCircle" class="mt-0.5 h-5 w-5 shrink-0 text-error-600" [strokeWidth]="2" />
          }
          <p class="flex-1 text-sm text-gray-800">{{ toast.message }}</p>
          <button
            class="shrink-0 rounded p-0.5 text-gray-400 hover:text-gray-600 transition-colors"
            (click)="toastService.remove(toast.id)"
          >
            <lucide-icon [img]="X" class="h-4 w-4" [strokeWidth]="2" />
          </button>
        </div>
      }
    </div>
  `,
})
export class ToastContainerComponent {
  toastService = inject(ToastService);

  readonly CheckCircle2 = CheckCircle2;
  readonly XCircle = XCircle;
  readonly X = X;
}
